import React from "react";
import { experience } from "../../mock";
import { Briefcase, MapPin } from "lucide-react";

export default function Experience() {
  return (
    <section
      id="experience"
      className="relative py-24 md:py-32 border-t border-zinc-900 overflow-hidden"
    >
      <div className="aurora -top-32 -left-32 opacity-20" aria-hidden />

      <div className="relative max-w-6xl mx-auto px-6 md:px-8">
        <div className="flex items-center gap-3 mb-3 reveal">
          <span className="mono text-xs section-num font-semibold">02 //</span>
          <span className="mono text-xs text-zinc-500 uppercase tracking-[0.2em]">
            Experience
          </span>
        </div>
        <h2 className="display text-4xl md:text-5xl font-semibold reveal">
          A track record{" "}
          <span className="text-zinc-500">of experience.</span>
        </h2>

        <div className="mt-14 relative">
          <div
            className="absolute left-[11px] md:left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-[#5eead4]/60 via-zinc-800 to-transparent"
            aria-hidden
          />

          <ol className="space-y-10 md:space-y-14">
            {experience.map((item, idx) => (
              <li
                key={item.id}
                className="relative pl-12 md:pl-16 reveal"
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                {/* Dot */}
                <div className="absolute left-0 top-1">
                  <div className="h-[24px] w-[24px] md:h-[40px] md:w-[40px] rounded-full border border-[#5eead4]/40 bg-[#0b0b0d] grid place-items-center">
                    <Briefcase size={14} className="text-[#5eead4]" />
                  </div>
                </div>

                <div className="card-hover border border-zinc-900 rounded-2xl p-6 md:p-7 bg-[#0b0b0d]">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div>
                      <h3 className="display text-xl md:text-2xl text-white">
                        {item.role}
                      </h3>
                      <div className="text-sm text-zinc-400 mt-1">
                        <span className="text-[#5eead4]">{item.company}</span>{" "}
                        <span className="text-zinc-700 mx-1">·</span>
                        <span className="inline-flex items-center gap-1 text-zinc-500">
                          <MapPin size={12} /> {item.location}
                        </span>
                      </div>
                    </div>
                    <div className="mono text-[11px] uppercase tracking-widest text-zinc-400 border border-zinc-800 rounded-full px-3 py-1.5 w-max">
                      {item.period}
                    </div>
                  </div>

                  <ul className="mt-5 space-y-2.5 text-sm text-zinc-400 leading-relaxed">
                    {item.points.map((p, i) => (
                      <li key={i} className="flex gap-3">
                        <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#5eead4] shrink-0" />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
